var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import PopoverAlignmentEnum from '../../enums/PopoverAlignmentEnum.js';
import PopoverPositioner from '../popover-positioner/PopoverPositioner.js';
/**
 * Popover class.
 *
 * @event animationEnd When animation end.
 *
 * @slot Element to trigger popover.
 */
export default class Popover extends KompisElement {
    constructor() {
        super(...arguments);
        // Alignment of popover.
        this.alignment = PopoverAlignmentEnum.center;
        // Direction of popover.
        this.direction = null;
        // Z index.
        this.zIndex = 3000;
        // Visible.
        this.visible = false;
        // Enabled wiggle.
        this.wiggle = false;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        const { color, border } = this.theme;
        return html `
			<style>
				kompis-popover-positioner {
					position: absolute;
					left: 0;
					right: 0;
					bottom: 0;
					top: 0;
				}
				.content {
					color: ${color.neutral.grey900};
					background-color: ${color.neutral.white};
					border-radius: ${border.radius.radius8 / 16}rem;
					border-width: 0;
					box-shadow: 0 ${4 / 16}rem ${16 / 16}rem rgba(0, 0, 0, 0.1);
				}
			</style>
			${this.getPopoverPositioner()}
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-popover-positioner', PopoverPositioner);
        super.connectedCallback();
    }
    /**
     * The intersection between iframe and visible area.
     *
     * @returns - Html.
     */
    getPopoverPositioner() {
        if (!this.visible) {
            return null;
        }
        return html `
			<kompis-popover-positioner
				@animationEnd="${() => this.dispatchEvent(new CustomEvent('animationEnd', { bubbles: true }))}"
				.visible="${this.visible}"
				.theme="${this.theme}"
				.wiggle="${this.wiggle}"
				.zIndex="${this.zIndex}"
				.alignment="${this.alignment}"
				.direction="${this.direction}"
			>
				<div class="content">
					<slot></slot>
				</div>
			</kompis-popover-positioner>
		`;
    }
}
__decorate([
    property({ type: String })
], Popover.prototype, "alignment", void 0);
__decorate([
    property({ type: String })
], Popover.prototype, "direction", void 0);
__decorate([
    property({ type: Number })
], Popover.prototype, "zIndex", void 0);
__decorate([
    property({ type: Boolean })
], Popover.prototype, "visible", void 0);
__decorate([
    property({ type: Boolean })
], Popover.prototype, "wiggle", void 0);
__decorate([
    property({ type: Object, required: true })
], Popover.prototype, "theme", void 0);
//# sourceMappingURL=Popover.js.map